import { render, staticRenderFns } from "./OnBoarding.vue?vue&type=template&id=2cce3746&scoped=true"
import script from "./OnBoarding.vue?vue&type=script&lang=ts"
export * from "./OnBoarding.vue?vue&type=script&lang=ts"
import style0 from "./OnBoarding.vue?vue&type=style&index=0&id=2cce3746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cce3746",
  null
  
)

export default component.exports